function createState() {
  return {
    category: [],
    categories: {},
    allCategories: [],
    searchOptions: {},
    homeData: {},
    loading: false,
    categoryTree: [],
    calendars: [],
    mostCommonEntryLayout: {},
    recentlyDeleted: [],
    analytics: null,
    datadogAnalytics: null,
    twitterFeeds: [],
    castScreens: [],
    siteSwitcherSites: [],
  };
}

export default createState;
